<script setup>
import StoreFrontDefaultLayout from "@/Layouts/StoreFrontDefaultLayout.vue"
import CInfiniteScrollProductList from "@/Components/CInfiniteScrollProductList.vue"
import CBreadcrumb from "@/Components/CBreadcrumb.vue"
import {Head, router, usePage} from "@inertiajs/vue3"
import CScrollToTop from "@/Components/CScrollToTop.vue"
import {computed, ref, watch} from "vue";
import PartnerStoreFrontDefaultLayout from "@/Layouts/PartnerStoreFrontDefaultLayout.vue"
import CVerticalProductsFilter from "@/Components/CVerticalProductsFilter.vue";

const page = usePage()
let props = defineProps({
    productList: Object,
    breadcrumbs: Object,
})

const hasFilterModules = true
const sortOptions = computed(() => page.props.sortOptions);
const selectedSort = ref(page.props.sortBy ?? "Ordenar por:")

watch(selectedSort, (newSort) => {
    if (newSort) {
        const listParams = route().params
        delete listParams.page

        router.get(route(route().current(), {...listParams, sortBy: newSort}), {}, {preserveState: false})
    }
})

defineOptions({
    layout: portalOptions?.mainPortal ? StoreFrontDefaultLayout : PartnerStoreFrontDefaultLayout
})
</script>

<template>
    <Head :title="'Produtos' + (category ? ' | ' + category.title : '')" />
    <v-container fluid>
        <v-row>
            <v-col md="3" xl="2" v-if="!$vuetify.display.mobile && hasFilterModules">
                <c-vertical-products-filter :product-list="productList"/>
            </v-col>
            <v-col class="pr-10">
                <v-row>
                    <v-col md="10">
                        <c-breadcrumb :items="breadcrumbs"/>
                    </v-col>
                    <v-col md="2" align-self="center" class="text-right">
                        <v-select
                            v-model="selectedSort"
                            :items="sortOptions"
                            item-title="title"
                            item-value="value"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-img
                            v-if="props.productList.category"
                            :src="props.productList.category.banner_url"
                            width="100%"
                        />
                    </v-col>
                </v-row>

                <c-infinite-scroll-product-list :productList="productList" :has-filter-modules="hasFilterModules"/>
            </v-col>
            <c-scroll-to-top/>
        </v-row>
    </v-container>
</template>
